import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import api from "../../../_metronic/helpers/api";
import { showAlert } from "../../redux/reducers/alertSlice";
import {stringify} from "qs";


function useUtils() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const fetchFAQs = async ( limit=10, offset=0) => {
    const params = {
      limit,
      offset,
    };
  
    try {
      const response = await api.get(`/faq?${stringify(params)}`);
      if (response.data.status) {
        return response.data.data
      }
    } catch (error) {
      dispatch(
        showAlert({
          message:  error?.response?.data?.message || "Network Error",
          variant: "danger",
        })
      );
    }
  };

  const submitFAQ = async (data) => {
    try {
      const response = await api.post(`/faq`, data);
      if (response?.data?.status) {
        dispatch(
          showAlert({ message: "Successfully added", variant: "success" })
        );
        navigate("/faqlist");
      }
    } catch (error) {
      dispatch(
        showAlert({
          message: error?.response?.data?.message,
          variant: "danger",
        })
      );
    }
}

const onDelete = async (id, limit, offset) => {
  try {
    const response = await api.delete(`/faq/${id}`);
    console.log(response)
    if (response?.data?.status) {
      console.log("wded")
      dispatch(
        showAlert({ message: "Successfully deleted", variant: "success" })
      );
      return fetchFAQs(limit, offset)
    }
    
  } catch (error) {
    dispatch(
      showAlert({
        message: error?.response?.data?.message,
        variant: "danger",
      })
    );
  }
};

const handleEdit = async (id) => {
  try {
    const response = await api.get(
      '/faq/'+id
    );
    if (response.data.status) {
      return response.data.data;
    }
  } catch (error) {
    dispatch(
      showAlert({
        message: error?.response?.data?.message,
        variant: "danger",
      })
    );
  }
};

const modifyFAQ = async (id, data) => {

  try {
    const response = await api.patch(
      `/faq/${id}`,data
    );
    if (response.data.status) {
      dispatch(
        showAlert({
          message: `FAQ Modified`,
          variant: "success",
          timeout: "2000",
        })
      )
      navigate('/faqlist')
    }
  } catch (error) {
    dispatch(
      showAlert({
        message: error?.response?.data?.message,
        variant: "danger",
      })
    );
  }
};


  return {
    fetchFAQs,
    submitFAQ,
    onDelete,
    handleEdit,
    modifyFAQ
  };
}

export default useUtils;
